import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { scrollToWaitlist } from "@/lib/analytics";

interface MobileStickyBarProps {
  onScanClick: () => void;
  isVisible: boolean;
  variant?: "scan" | "upgrade";
}

const MobileStickyBar = ({ onScanClick, isVisible, variant = "scan" }: MobileStickyBarProps) => {
  if (!isVisible) return null;

  const handleClick = variant === "upgrade" ? () => scrollToWaitlist() : onScanClick;

  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] bg-background/95 backdrop-blur-lg border-t border-border z-40 md:hidden animate-slide-up">
      <Button 
        onClick={handleClick}
        className="w-full h-12 text-sm font-semibold gap-2 animate-pulse-button"
      >
        <Sparkles className="w-4 h-4" />
        {variant === "upgrade" ? "Request Full Audit" : "Scan My Brand"}
      </Button>
    </div>
  );
};

export default MobileStickyBar;
